export default "__VITE_ASSET__CjwM100O__"